export const en = {
  cookieInfo:
    'We use cookies to improve our website. You can block their saving on your computer by changing the settings of your browser. Find out more',
  here: 'here',
  hi: 'Hello',
  rememberMe: 'Remember me',
  contactWithUs: 'contact us',
  added: 'Added',
  disks: 'disks',
  name: 'Name',
  creditCard: 'Credit card',
  Country: 'Country',
  virtualMachines: 'Virtual machines',
  basicDisc: 'Primary disk',
  basicDiscShort: 'Primary disk',
  additionalDisc: 'Additional disk',
  additionalDiscShort: 'Additional disk',
  hardwareParameters: 'Hardware profile',
  invoicedCompany: 'Invoiced company',
  invoiceAddress: 'Invoice address',
  authorization: 'Authorization',
  password: 'Password',
  SSHKeys: 'SSH keys',
  choosen: 'Selected',
  change: 'change',
  privateNetwork: 'Private network',
  choosePrivateNetwork: 'Choose private network',
  or: 'or',
  addNew: 'Add new',
  summary: 'Summary',
  operatingSystem: 'Operating system',
  h: 'h',
  hour: 'per hour',
  month: 'mo',
  monthly: 'monthly',
  days: 'days',
  amount: 'Amount',
  bandwidth: 'Bandwidth',
  chooseOperatingSystem: 'Select operating system',
  chooseOSVersion: 'Select version',
  backToPanel: 'back to dashboard',
  back: 'back',
  physicalMachines: 'Physical machines',
  networks: 'Networks',
  network: 'Network',
  publicNetwork: 'Public IP addresses',
  other: 'Other',
  regions: 'Regions',
  generalView: 'General view',
  enabled: 'Enabled',
  turnOff: 'power off',
  turnOn: 'turn on',
  backup: 'Backup',
  backupOff: 'backup off',
  backupOn: 'backup on',
  contactUsToDeactivateBackup: 'Contact us to deactivate backup.',
  suspend: 'suspend',
  freeze: 'freeze',
  reboot: 'reboot',
  on: 'On',
  off: 'Off',
  busy: 'Busy',
  machine_error: 'Error',
  suspended: 'Suspended',
  total: 'total',
  sorting: 'Sorting',
  creationDate: 'Creation date',
  trialActivationPopupHeader: 'Trial successfully activated!',
  trialActivationPopupDescription: 'Current balance for workspace {name}: ',
  created: 'Created',
  createdBy: 'Created by',
  state: 'State',
  diskSpace: 'Disk space',
  delete: 'delete',
  console: 'console',
  description: 'Description',
  contents: 'Content',
  issueType: 'Issue type',
  date: 'Date',
  history: 'History',
  cost: 'Cost',
  costs: 'Costs',
  permissions: 'Permissions',
  billingPeriod: 'Billing period',
  details: 'Details',
  computing: 'Computing',
  licences: 'Licences',
  select: 'Select',
  address: 'Address',
  type: 'Type',
  additional: 'Additional',
  main: 'Primary',
  deleteSelected: 'Delete selected',
  addressing: 'Addressing',
  connectedMachines: 'Connected machines',
  machineName: 'Machine name',
  newMachineName: 'New machine name',
  action: 'Action',
  allow: 'allow',
  enterName: 'Enter a name',
  forWwwServer: 'For www server',
  downloadClient: 'Download VPN client',
  username: 'Username',
  enterUserName: 'enter username',
  enterUserEmail: 'enter e-mail',
  accountSettings: 'Account settings',
  logout: 'Logout',
  loginToOneStepCloud: 'Log in to One Step Cloud',
  dontYouHaveAnAccount: "You don't have an account?",
  doYouHaveAnAccount: 'You have an account?',
  nameAndSurname: 'Full name',
  changePassword: 'Change password',
  oldPassword: 'Old password',
  newPassword: 'New password',
  repeat: 'Repeat',
  TwoStepAuthentication: 'Two-step authentication',
  imprint: 'Imprint',
  SSHkeyName: 'SSH key name',
  SSHkeys: 'SSH keys',
  deleteAccount: 'Delete account',
  approved: 'Approved',
  waitingForConfirmation: 'Waiting for confirmation',
  emailIsNotActive: 'Email is not active. Waiting for confirmation.',
  SearchByName: 'Search by name',
  SearchByAddress: 'Search by IP',
  sshKeysAddNew: 'SSH keys / add new',
  key: 'Key',
  nofees: 'no fees',
  isEmpty: 'is empty.',
  isWrongFormat: 'Format is invalid.',
  notFound: 'not found',
  pageDoesNotExist: 'The page you are looking for does not exist',
  goToTheHomepage: 'Go to the home page.',
  isCollision: 'is in collision with another network',
  isConflict: 'NAT port ranges overlap with another NAT',
  increaseLimits: 'Increase limits',
  undoChange: 'Undo change',
  accept: 'accept',
  deny: 'drop',
  reject: 'reject',
  markedForRemoval: 'MARKED FOR REMOVAL',
  tooShort: 'is too short. Use min. 4 characters.',
  not_applicable: 'Not applicable',
  limitExceeded: 'Limit exceeded',
  monthlyValue: 'Estimated value assumes 730 hours per month.',
  sliderIncreaseLimit: 'To increase limits contact with us using help form.',
  language: 'Choose language',
  polish: 'polish',
  english: 'english',
  ie: 'i.e. 111-222-333',
  company: 'Company',
  privatePerson: 'Private individual',
  limitsReached: 'Limits reached',
  unableToActivate: 'unable to activate/deactivate',
  messageHasBeenSent: 'Message has been sent.',
  netto: 'net',
  diskCantBeNegativeError: 'It is not possible to reduce disk size.',
  sending: 'Sending...',
  loadingTransaction: 'Transaction in pregress...',
  timeInterval: 'Report range',
  diskHDD: 'Disk (HDD)',
  diskSSD: 'Disk (SSD)',
  backupStorage: 'Backup storage',
  win10: 'Operating system',
  machinesQuantity: 'Machines quantity',
  checkEmail: 'Please check your email.',
  hasBeenBlocked: 'The workspace has been blocked',
  administrativelyAnd: 'administratively and',
  lackOfFunds: 'due to lack of funds.',
  lackOfPayment: 'due to the lack of payment.',
  endOfTheTrialPeriod: 'due to the end of the trial period.',
  deletionBlockReason: 'due to account deletion process.',
  administratively: 'by administrator.',
  sendUnlockRequest: 'Send the unlocking request.',
  and: 'and',
  resign: 'resign',
  params_invalid: 'Please complete the form.',
  activeSessions: 'Active sessions',
  currentSession: 'Current session',
  expires: 'Expires',
  lastActivity: 'Last activity',
  unknownDevice: 'Unknown device',
  accessTheConsole: 'Send console access request',
  console_inaccessible: 'Console is inaccessible.',
  console_access_limit_exceeded: 'Console access limit exceeded.',
  console_access_granting_failed: 'Console access granting failed.',
  pleaseTryInAFewMinutes: 'Please try in a few minutes.',
  nameAscending: 'Name ascending',
  nameDescending: 'Name descending',
  backupActivated: 'Backup activated',
  dateRangePicker: {
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Apply',
    cancelLabel: 'Cancel',
    weekLabel: 'W',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    firstDay: 0,
  },
  ws: {
    transferUpdate: 'Transfer usage updated.',
    firewallUpdated: 'Firewall configuration successfully updated.',
    backupActivated: 'Backup activated.',
    dm: {
      reserve: {
        requested: 'Dedicated machine reservation in progress...',
        succeeded: 'Dedicated machine reservation succeeded.',
        failed: 'Dedicated machine reservation failed.',
      },
      update: {
        succeeded: 'Dedicated machine update succeeded.',
      },
      resign: {
        requested: 'Dedicated machine resignation in progress...',
        succeeded: 'Dedicated machine resignation succeeded.',
        failed: 'Dedicated machine resignation failed.',
      },
      power_on: {
        started: 'Starting dedicated machine...',
        succeeded: 'Dedicated machine started.',
        failed: 'Failed to start dedicated machine.',
      },
      power_off: {
        started: 'Shutting down dedicated machine...',
        succeeded: 'Dedicated machine shut down.',
        failed: 'Shutting down dedicated machine failed.',
      },
      reset: {
        started: 'Restarting virtual machine...',
        succeeded: 'Dedicated machine restarted.',
        failed: 'Restarting  dedicated machine failed.',
      },
      destroy: {
        succeeded: 'Dedicated machine removed.',
      },
    },
    vm: {
      transferUpdate: 'Transfer usage updated.',
      hardware: {
        started: 'Updating virtual machine resources...',
        succeeded: 'Virtual machine resources updated.',
        failed: 'Failed to update virtual machine resources.',
      },
      create: {
        started: 'Creating virtual machine in progress.',
        succeeded: 'Virtual machine created. Please check e-mail.',
        failed: 'Creating virtual machine failed.',
      },
      update: {
        started: 'Updating virtual machine...',
        succeeded: 'Virtual machine updated.',
        failed: 'Updating virtual machine failed.',
      },
      powerOn: {
        started: 'Starting virtual machine...',
        succeeded: 'Virtual machine started.',
        failed: 'Failed to start virtual machine.',
      },
      powerOff: {
        started: 'Shutting down virtual machine...',
        succeeded: 'Virtual machine shut down.',
        failed: 'Shutting down virtual machine failed.',
      },
      suspend: {
        started: 'Putting virtual machine in sleep mode... ',
        succeeded: 'Virtual machine in sleep mode.',
        failed: 'Virtual machine sleep mode failed.',
      },
      restart: {
        started: 'Restarting virtual machine...',
        succeeded: 'Virtual machine restarted.',
        failed: 'Restarting  virtual machine failed.',
      },
      destroy: {
        succeeded: 'Virtual machine removed.',
      },
    },
    workspace: {
      workspace_blocked: 'Workspace blocked.',
      workspace_unblocked: 'Workspace unblocked.',
      update_name: {
        succeeded: 'Workspace name changed.',
      },
      workspace_deleted: 'Workspace removed.',
      users: {
        roleUpdate: 'User role changed.',
        usernameUpdate: 'User name changed.',
        destroy: 'User removed.',
        invitation: {
          create: 'Invitation sent.',
          destroy: 'Invitation cancelled.',
        },
      },
    },
    usage_limit: {
      update: {
        succeeded: 'Usage limits changed.',
      },
    },
    current_usage: {
      changed: 'Usage limits changed.',
    },
    public_ip_address: {
      create: {
        started: 'Adding public IP address...',
        succeeded: 'Public IP address added.',
        failed: 'Adding public IP address failed.',
      },
      destroy: {
        started: 'Removing public IP address...',
        succeeded: 'Public IP address removed.',
        failed: 'Removing public IP address failed.',
      },
    },
    private_network: {
      create: {
        started: 'Private network creating...',
        succeeded: 'Private network created.',
        failed: 'Failed to create a private network.',
      },
      destroy: {
        started: 'Removing private network...',
        succeeded: 'Private network removed.',
        failed: 'Failed to remove the private network.',
      },
      update: {
        started: 'Updating private network...',
        succeeded: 'Private network updated.',
        failed: 'Private network update failed.',
      },
      changed: 'Private network changed.',
    },
    nat: {
      create: {
        started: 'Creating NAT...',
        succeeded: 'NAT created.',
        failed: 'Failed to create NAT.',
      },
      destroy: {
        started: 'Removing NAT...',
        succeeded: 'NAT removed.',
        failed: 'Failed to remove NAT.',
      },
      changed: 'NAT changed.',
    },
    nic: {
      create: {
        started: 'Creating a network interface...',
        succeeded: 'Network interface created.',
        failed: 'Network interface creation failed.',
      },
      update: {
        started: 'Updating the network interface...',
        succeeded: 'Network interface updated.',
        failed: 'Network interface update failed.',
      },
      destroy: {
        started: 'Removing the network interface...',
        succeeded: 'Network interface removed.',
        failed: 'Failed to remove the network interface.',
      },
      changed: 'Network interface changed.',
    },
    auditLog: {
      started: 'Creating audit log entry...',
      succeeded: 'Audit log entry created.',
      failed: 'Failed to create audit log entry.',
    },
    region: {
      activate: {
        started: 'Activating region...',
        succeeded: 'Region activated.',
        failed: 'Region activation failed.',
      },
      destroy: {
        succeeded: 'The deactivation of the region has been successful.',
        failed: 'Failed to deactivate the region.',
      },
    },
    snapshot: {
      create: {
        started: 'Creating snapshot...',
        succeeded: 'Snapshot created.',
        failed: 'Snapshot creation failed.',
      },
      restore: {
        started: 'Restoring snapshot...',
        succeeded: 'Snapshot restored.',
        failed: 'Snapshot restoration failed.',
      },
      destroy: {
        started: 'Removing snapshot...',
        succeeded: 'Snapshot removed.',
        failed: 'Snapshot removal failed.',
      },
    },
    default: 'Unsupported error {name}',
  },
  serverErrorOccured: 'Server error occured.',
  maintenance: "We're working on improving the portal. Check back later.",
  accountIsInactive: 'Account inactive.',
  accounts: {
    removePopup: {
      header: 'Your account will be deleted.',
      description:
        'Deleting your account cannot be reversed. Once your account is deleted, you will be redirected to the home page. You can find other information about deleting your account in the account deletion documentation.',
    },
  },
  individualPerson: 'Private individual',
  taxNumber: 'Tax ID',
  advert: {
    howItWorks: 'How does it work?',
    howItWorksDescription:
      'One Step Cloud is a ready-to-use and easy-to-use platform for providing and managing dedicated machines, virtual machines, administration services and user support.',
    faq: 'Frequently asked questions',
    userDocumentation: 'User documentation',
    allRightsReserved: 'All rights reserved © 2021',
  },
  validation: {
    fieldIsRequired: 'The field is required.',
    agreementIsRequired: 'Consent is required.',
    used: 'already in use.',
    isInvalid: 'invalid.',
    isTooShortMin2: 'The field is too short. Minimum 2 characters required.',
    isTooShortMin4: 'The field is too short. Minimum 4 characters required.',
    isTooShortMin3: 'The field is too short. Minimum 3 characters required.',
    isTooShortMin8: 'Password is too short. Use at least 8 characters.',
    isTooLongMax10: 'The field is too long. Use up to 10 characters.',
    isTooLongMax16: 'The field is too long. Use up to 16 characters.',
    isTooLongMax50: 'The field is too long. Use up to 50 characters.',
    isTooLongMax64: 'The field is too long. Use up to 64 characters.',
    isTooLongMax255: 'The field is too long. Use up to 255 characters.',
    isTooLongMax1000: 'The field is too long. Use up to 1000 characters.',
    isTooLongMax1024: 'The field is too long. Use up to 1024 characters.',
    alreadyInUse: 'already in use.',
    emailAlreadyInUse: 'The email address you entered is already in use.',
    wrongPassword: 'Incorrect password.',
    passwordDoesNotMatch: 'Incorrectly repeated password.',
    improvePasswordStrength: 'Provide a stronger password.',
    wrongEmailFormat: 'Incorrect email address format.',
    emailOrPassIsWrong: 'Email or password incorrect.',
    oldPassIsInvalid: 'Current password incorrect.',
    passDoesNotMatch: 'Password repeated incorrectly.',
    invalidFileType: 'Incorrect file type. Correct formats are png or jpg.',
    tooBigFile: 'File too large. Maximum file size is 6MB.',
  },
  limitsText: 'If you wish to increase the limits of your workspace resources, please send us a request.',
  buttons: {
    activateBackup: 'ACTIVATE BACKUP',
    SKIP: 'SKIP',
    goToPanel: 'GO TO PANEL',
    ADDDISC: 'ADD DISK',
    CANCEL: 'CANCEL',
    SAVE: 'SAVE',
    ADD: 'ADD',
    NEXT: 'NEXT',
    CHOOSE: 'CHOOSE',
    creditCard: 'CREDIT CARD',
    DELETE: 'DELETE',
    REMOVE: 'REMOVE',
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
    CREATE: 'CREATE',
    CHANGE: 'CHANGE',
    ACTIVATE: 'ACTIVATE',
    TRIAL: 'TRIAL',
    CONFIRM: 'CONFIRM',
    RESEND: 'RESEND',
    SEND: 'SEND',
    DETAILS: 'DETAILS',
    RESTORE: 'RESTORE',
    MAKE: 'MAKE',
    addNat: 'ADD NAT',
    addNetworkCard: 'ADD NETWORK CARD',
    addNatMapping: 'ADD NAT MAPPING',
    DISPLAY: 'DISPLAY',
    RESIGN: 'RESIGN',
    contactWithUs: 'CONTACT US',
    downloadClient: 'DOWNLOAD CLIENT',
    createPrivateNetwork: 'CREATE PRIVATE NETWORK',
    goToThePortal: 'GO TO THE PORTAL',
    LOGIN: 'LOG IN',
    forgotPassword: 'FORGOT PASSWORD',
    register: 'REGISTER',
    TURNON: 'TURN ON',
    sendInvitation: 'SEND INVITATION',
    saveNewPassword: 'SAVE NEW PASSWORD',
    addNewSSHKey: 'ADD NEW SSH KEY',
    saveAllChanges: 'SAVE ALL CHANGES',
    addUser: 'ADD USER',
    accept: 'ACCEPT',
    settings: 'SETTINGS',
    request: 'SEND REQUEST',
    commingSoon: 'COMING SOON',
    display: 'DISPLAY',
    used: 'USED',
    RENT: 'RENT',
  },
  tooltip: {
    insufficientPermissions: 'Insufficient permissions to access the console.',
    lackOfFunds: 'No resources. The workspace account balance is 0 and payment is not possible.',
    checkTaxRegulations: 'Check the tax regulations in your country.',
    outputAddress: 'Public IP address for outgoing traffic from the interface.',
    outputAddressNetwork: 'Default public IP address for outgoing traffic from the network.',
    addressingCIDR: 'The address in CIDR notation must come from one of the IANA private networks (RFC1918)',
    addressingReservedByOSC: 'Subnets reserved by One Step Cloud',
    source:
      'Matching packets whose source is equal to the specified IP address, network card or falls into the provided subnet or private network.',
    sourcePort: 'Port or range of source ports. Only if the protocol is TCP or UDP.',
    destination:
      'Matches packets whose destination is equal to the specified IP address, network card or falls into the provided subnet or private network.',
    destinationPort: 'Port or range of destination ports. Only if the protocol is TCP or UDP.',
    protocol: 'Adjusts the IP packet protocol.',
    promocodeActualSum: 'The amount shown is the current total of the promo code and prepaid funds.',
    nip: 'Tax identification number assigned to companies registered in Poland.',
    ueVat:
      'A tax number assigned by the local authorities of European Union member states. If you do not have a VAT-EU number, enter your local tax ID number.',
    taxNumber: 'The local tax ID number applicable in the country where the company is registered.',
    currentCost: 'The amount shown is the accrued cost from the beginning of the month to now.',
    expectedCost: 'Expected cost for the current month.',
    machineType: {
      dedicated: 'Network for dedicated machines.',
      virtual: 'Network for virtual machines.',
    },
  },
  agreement: {
    customSolution: 'INDIVIDUAL OFFER',
    subtitle: 'Payments are made on an individual basis.',
    infoAfterRequest: 'Thank you! We will contact you shortly to arrange the details of our cooperation.',
  },
  scripts: {
    fullNameRequired: 'First and last name are required.',
    fullNameTooShort: 'First and last name too short. Use at least 4 letters.',
    fullNameTooLong: 'The first and last name are too long. Use up to 60 characters.',
    emailRequired: 'Email address required.',
    emailFormatIsWrong: 'Incorrect email address format.',
    emailIsAlreadyInUse: 'Email address already in use.',
    errorOccuredDuringActivation: 'An error occurred while accepting an invitation.',
    errorLoggedInToDifferentAccount: 'Error: You are logged into an account other than the one from the invitation.',
    usernameIsRequired: 'User name required.',
    usernameIsTooShort: 'User name too short. Use at least 4 characters.',
    usernameFormatIsWrong: 'User name can contain only letters, digits and the sign - _',
    usernameIsTaken: 'User name already in use.',
    insufficientPermissions: 'Insufficient permissions.',
    descriptionIsTooShort: 'The description is too short. Use a minimum of 10 characters.',
  },
  pass: {
    successfullPassChange: 'You have successfully updated your password.',
    logInToContinue: 'Please log in to continue the process of changing your email address.',
    loginAgain: 'Please login again',
    twoStepAuthenticationInfo:
      'The change takes place in two stages. A message will be sent to your old address asking you to confirm the change of the email address. An email will then be sent to your new address with a link to confirm that the new email address is assigned to your account.',
    confirmationLinksInfo:
      'e-mail address change requested. Confirmation links have been sent to the old and new addresses.',
    forgotPass: 'Forgot your password?',
    forgotPassInfo:
      'Enter the email that you use to log into your account. A message with a password reset link will be sent to this address.',
    resetPass: 'SEND PASSWORD RESET EMAIL',
    resendInfo: 'Message with password reset link not received? Click below to resend it.',
    messageSent:
      'If the e-mail address provided is connected to a customer account, a link will be sent to change the password.',
    setNewPass: 'SET NEW PASSWORD',
    newPass: 'New password',
    repeatNewPass: 'Repeat new password',
    confirmAndGoToPanel: 'CONFIRM AND GO TO PANEL',
    byClicking: 'By clicking REGISTER, you agree to our',
    termsOfService: 'Terms of service',
    termsOfServiceLink: 'https://onestepcloud.pl/legal.html',
    privacyStatement: 'Privacy Policy',
    privacyStatementLink: 'https://onestepcloud.pl/policy.html',
    occasionallySend: 'From time to time we will send you emails related to your account.',
    and: 'and',
    createVMs: 'Create virtual machines in just a few steps',
    manageVMs: 'Manage your environment',
    scalableVMs: 'Scalable infrastructure',
    payLessForVMs: 'Pay less for virtual machines',
    invalidProvidedToken: 'The token provided is not valid. Password change failed.',
    deleteAccountWarn: 'To delete an account, delete workspace first.',
    deleteAccountInfo:
      'When you delete your account, you lose access to the account services and your personal data is permanently deleted.',
  },
  leftMenu: {
    virtualMachines: 'VIRTUAL MACHINES',
    dedicatedMachines: 'DEDICATED MACHINES',
    network: 'NETWORK',
    vpn: 'VPN',
    help: 'HELP FORM',
    localizationSettings: 'LOCAL SETTINGS',
    publicIPaddress: 'Public IP addresses (NAT)',
    privateNetwork: 'Private networks',
    routing: 'Routing',
    firewall: 'Firewall',
    settings: 'SETTINGS',
    billing: 'BILLING',
    users: 'USERS',
    logs: 'LOGS',
  },
  virtualMachine: {
    noMachines: 'There are no machines that match your search criteria.',
    firstVMInfoPart1: 'My first VM ready - what next?',
    firstVMInfoPart2: "We have send VM's connection details on your e-mail already. Please chceck SPAM folder.",
    firstVMInfoPart3: 'You can publish it via Public IP address or connect using VPN.',
    firstVMInfoPart4: 'To connect to your VM, please follow instruction on:',
    workspaceIsBlocked: 'Workspace blocked.',
    cantAddNew: 'It is not possible to add a new machine.',
    contactToUnblock: 'Contact us to unblock',
    consolePopup: {
      header: 'Console access',
      subheader: "You don't have permissions that allow the console access.",
    },
    newSection: {
      mandatoryFields: 'Required fields.',
    },
    winLicenceCheckbox:
      'I agree to Intratel sp. z o.o. having administrative access to the created operating system. Such access shall only be used for SPLA reporting purposes to Microsoft sp. z o.o.',
    storage: 'Storage',
    wrongVMState: 'Saving changes to the virtual machine configuration.',
    suspendedState: 'It is not possible to change the hardware settings when the machine is in sleep mode.',
    restartInfo: 'The machine will restart following changes in the amount of vCPU or RAM.',
    snapshotExists: 'Delete the snapshot before changing hardware settings.',
    snapWrongVMState: 'Saving changes to the virtual machine configuration.',
    noVirtualMachines: 'No virtual machines',
    insufficentPermissions: 'Insufficient permissions to create a new machine for a "read-only" role.',
    createFirstVM: 'Create your first virtual machine',
    create: 'CREATE',
    createDescription:
      'In the OSC you can create a virtual server (VPS) based on operating systems such as Ubuntu, Microsoft Windows Server, Centos, Debian, etc.',
    edit: 'Edit and manage',
    editDescription:
      'You can increase or decrease computing resources, add or remove drives to change the amount of disk space required by your machine to function.',
    pay: 'Pay for what you use',
    payDescription:
      'You are billed on a  per second basis for equipment usage, and the provided API allows the software to turn machines on and off whenever you need it.',
    createNewMachine: 'CREATE A NEW MACHINE',
    dedicatedMachines: 'DEDICATED MACHINES',
    newVirtualMachine: 'New virtual machine',
    ToIncreaseTheQuantity: 'In order to increase the number of',
    egVirtualMachine: 'e.g. virtual_machine',
    virtualMachine: 'Virtual machine',
    privateIPAddresses: 'Private IP addresses',
    overcharged: 'Billed',
    remained: 'Until',
    expenditure: 'Current use',
    machineCostsWarning: 'Note! The changes you make will affect the cost of the machine.',
    totalValueofChanges: 'Total value of changes',
    costAfterChanges: 'Cost of the machine after changes',
    snapshotText:
      'Snapshot is an option to archive the current settings and state of a virtual machine with all the data on it. Requires additional space (data + currently used RAM).',
    snapshotShouldBeRemoved: 'Snapshots should not be older than 3 days.',
    restoreSnapshotText:
      'Your virtual machine will revert to its original state from the restore point. Remember to delete the snapshot up to 3 days after taking it. Storing a snapshot for a long time can negatively affect the performance of that VM.',
    deleteSnapshotText:
      'If you delete a snapshot, you will lose the ability to restore the VM from the specified period.',
    createSnapshotText:
      'Remember to delete the snapshot up to 3 days after it has been taken. Keeping a snapshot for a longer period of time may adversely affect the performance of that VM.',
  },
  dedicatedMachine: {
    rentDedicatedMachine: 'RENT A DEDICATED MACHINE',
    dedicatedMachines: 'Dedicated machines',
    dedicatedMachine: 'Dedicated machine',
    specification: 'Model',
    dateOfRent: 'Rental date',
    theMinimumRentalPeriod: 'Minimum rental period',
    theMinimumRentalCost: 'Minimum rental cost',
    additionally: 'Additionally',
    noPermissionsToRentDM:
      'You are not authorized to rent a dedicated machine. Update your payment method to use them.',
    lackOfFunds: 'No permissions during the TRIAL.',
    noDedicatedMachinesAvailable: 'The product is currently unavailable.',
    insufficentPermissions: 'Insufficient permissions to rent dedicated machine for the "read-only" role.',
    minUsageFundsMissing: 'There are insufficient funds to cover the minimum cost.',
    noFundsToRentDM: 'Go to settings or contact us to top up your workspace account.',
  },
  keysConf: {
    availableSSHkeys: 'List of available SSH keys',
    chooseKyes: 'Select keys from the list',
    orAddNewKey: 'or add a new SSH key',
    choosenKeys: 'Selected keys',
    emptyList: 'The list is empty',
    noSelected: 'No SSH keys selected',
    dontHaveKey: "Don't have an SSH key?",
    learnHowTo: 'Find out how',
    generateSSHKey: 'to generate an SSH key',
    docsLink: 'https://docs.onestepcloud.pl/u%C5%BCytkownicy/managing-ssh-keys',
    newKey: 'New key',
    emptyKeysListInfo: 'The selected key list is empty. Add an SSH key.',
  },
  dedicatedPublicIpAddress: {
    label: 'Public virtual machine',
    limitErrorInfo: 'You can not add a dedicated public IP address because the limit has been reached.',
    description: 'Bind the machine to the a public address. NAT one-to-one mapping will be created between the two.',
    paragraph: 'Primary public IP address is provided to your workspace. Dedicated one is extra paid and not required.',
  },
  net: {
    addNewPrivateNetwork: 'Add a new private network',
    addingNewPNIsInProgress:
      'The process of adding a new private network has started. Please wait for the intrastructure to be created.',
    requiredDedicatedNetwork:
      'The dedicated private network is required to rent a machine. You can create it  in the private networks tab.',
    canNotDeleteAddress: 'The address cannot be deleted!',
    addressIsUsedForPN: 'The address is used as the outbound address for the network ',
    addressIsUsedForNIC: 'The address is used as the outbound address for the network interface ',
    inTheMachine: 'in the machine',
    createdNATMappings: 'There are existing NAT mappings.',
    natsWillBeDeleted: 'They will be deleted along with the address.',
    cantDeletePrimary: 'The primary public IP address cannot be deleted.',
    cantDeletePrivateNetwork: 'You can not delete a private network if a machine is connected.',
    restartRequired:
      'A reboot or a DHCP request from the operating system is required for the machine to retrieve a new IP address.',
    insufficentPermissions: 'Insufficient permissions to create a new machine for a "read-only" role.',
    firewallInsufficentPermissions: 'Insufficient permissions to configure firewall rules for the "read-only" role.',
    firewallRulesSaved: 'Firewall configuration changes successfully saved.',
    wrongVMState: 'Saving changes to the virtual machine configuration.',
    defaultForPrivateNet: 'Default for private network',
    UnableToConnect: 'Cannot connect to your machine!',
    addOneNetwork: 'To do this, you need to add at least one network card.',
    UnableToConnectWithoutNAT: 'There are currently no NAT mappings added.',
    addOneNat: 'Add the first NAT mapping.',
    networkCard: 'Network card',
    networkCardName: 'Network card name',
    cantAddMoreNics: 'No more network cards can be added because all private networks have already been used.',
    anyInfo: 'Not only TCP/UDP; ANY is responsible for remapping all IP packets regardless of protocol.',
    privateAddress: 'IP address',
    outputAddress: 'Output address',
    defaultForPrivateNetwork: 'Default for private network',
    default: 'Default',
    NATmappings: 'NAT mappings',
    emptyNATmappings: 'There are currently no NAT mappings added. Add the first NAT mapping.',
    addNat: 'ADD NAT',
    createFirewallRule: 'Create a firewall rule',
    IPaddress: 'IP address',
    publicIPaddress: 'Public IP addresses (NAT)',
    privateIPaddress: 'Private IP address',
    protocol: 'Protocol',
    publicPort: 'Public port',
    localPort: 'Local port',
    sourcePort: 'Source port',
    destinationPort: 'Destination port',
    source: 'Source',
    destination: 'Destination',
    associatedNAT: 'Related NAT',
    associatedPN: 'Associated private network',
    PublicIPaddresses: 'Public IP addresses',
    addPublicIpAddress: 'ADD PUBLIC IP ADDRESS',
    numberOfMappings: 'Number of NAT mappings',
    createPrivateNetwork: 'Create private network',
    removePrivateNetwork: 'REMOVE PRIVATE NETWORK',
    defaultPublicAddress: 'Outbound public address',
    publicIPAddressDialogInfo: 'Adding a new public IP address will increase the cost of running the infrastructure.',
    createNewRule: 'CREATE A NEW RULE',
    firewallRulesInfo: 'Rules are processed in ascending order. The first matching rule will be used.',
    vpnDialogInfoPart1: 'Enter your VPN password. You can find them in the email we sent',
    vpnDialogInfoPart2: 'the user is added to a VPN service in the region',
    isWrongRange: 'Invalid port range',
    noConnectedMachines: 'No connected machines',
    privateNetworksLimit: 'The limit for private networks is 7. You cannot add more private networks.',
    publicIpAddressesLimit: 'Adding a new public IP address will increase the cost of running the infrastructure.',
    UnableToCreateNatWithoutVM: 'It is not possible to create mappings when there is no virtual machine.',
    createVM: 'Create a virtual machine',
    machineType: 'Type',
    noDedicatedNetworks: 'No dedicated networks',
    type: {
      virtual: 'Virtual',
      dedicated: 'Dedicated',
    },
  },
  vlan_limit_reached: 'Reached maximum number of created vlans.',
  private_networks_limit_reached: 'Reached maximum number of created private networks.',
  private_network_with_nics: 'Cannot remove network with connected interfaces.',
  settings: {
    name: 'Name',
    mySettings: 'My settings',
    nick: 'Nick: (Optional)',
    nickToolTipInfo: 'Set the Nickname you want to display to other users in this Workspace',
    emailNotifications: 'E-mail notifications',
    unsubscribeFromWorkspace: 'Unsubscribe from workspace',
    workspaceSettings: 'Workspace settings',
    ForceTwoFactorAuthentication: 'Force two-step authentication',
    deleteWorkspace: 'Delete workspace',
    sendRemoveConfirmationEmail: 'Send confirmation',
    deleteWorkspaceConfirm: 'Are you sure you want to delete workspace',
    deleteWorkspaceDescription:
      'Deleting a workspace involves removing all infrastructure, reports and any information contained within it.\n' +
      'When a workspace is deleted, the billing period is closed and funds are taken from your account. \n' +
      'If it is not possible to pay  for the billing period - the process will stop.',
    deleteWorkspaceEmail: 'A link  will be sent to your email address confirming the deletion of your workspace.',
    deleteWorkspaceEmailHasBeenSend: 'Confirmation email sent. Please check your email.',
    deleteWorkspaceInfo:
      'Are you sure you want to delete workspace? You can also transfer it to another user. You can find more information on how to do this in the documentation.',
    workspaceRemovalIsInProgress: 'Workspace is currently being deleted.',
    signOff: 'UNSUBSCRIBE',
    deleteWorkspaceConditions: 'To delete your workspace, please contact us using help form.',
    afterLeaving: 'Once you leave',
    willBeAnonymized: 'all your data and logs of operations performed by you are anonymised.',
    trialExpiredDeleteInfo:
      'The trial period has ended and your workspace has been blocked. Top up your account or contact us to unlock  and then delete your workspace.',
    billingOverdueDeleteInfo:
      'Your workspace is currently blocked due to overdue payments. Settle your overdue payments and unblock the workspace to delete it.',
    blockedWorkspaceDeleteInfo:
      'Failed to automatically collect payment for the last billing period. Settle the payment to delete your account.',
    startTheRemovalProcess: 'Start the deletion process',
    tokenIsInvalid: 'The token is invalid or expired. Tokens are valid for 1 hour.',
    deletionProccessIsInProgress: 'Deleting...',
    successfullyRemovedWorkspace: 'Workspace successfully deleted.',
    removalHasFailed:
      'The overdue billing periods could not be paid, so the workspace deletion failed. Settle overdue payments to resume deleting your workspace.',
    requestToRemoveIfContract:
      'An agreement has been concluded (individual offer). Contact us to terminate the agreement.',
    removeWorkspaceRequest: 'I would like to terminate the agreement.',
    removeWorkspaceMessageSent: 'Request for removal of workspace (agreement termination) sent',
    infoAfterRemoveRequest: 'Thank you! We will contact you shortly to terminate the agreement.',
  },
  billing: {
    contract_signed: 'Contract has been signed',
    leftTopay: 'chargeable',
    freeBandwidthOut: 'Free outbound transfer',
    freeBandwidth: 'Outbound bandwidth is free in this region.',
    usedBandwidth: 'Used outbound bandwidth',
    bandwidthPart1: 'In this Region the Bandwidth up to',
    bandwidthPart2: 'is free. We will charge you',
    bandwidthPart3: ' per 10GB each over it',
    trialContact: 'Please contact me about the trial.',
    trialSent: 'Trial activation request was sent.',
    contractContact: 'Please contact me about the agreement.',
    netPrices: 'The prices quoted are net prices.',
    anotherTerm: 'Another term',
    promocodeInfo:
      'A promo code will increase the balance of the respective workspace. The promo code can be used only once.',
    euVat: 'EU VAT',
    companyName: 'Company name',
    currency: 'Currency',
    address: 'Address',
    zipCode: 'Zip code',
    city: 'City',
    regions: 'Regions',
    state: 'State',
    billing: 'Billing',
    taxRate: 'Tax rate',
    pricingType: 'Billing type',
    agreement: 'Contract (individual offer)',
    taxNumber: 'Tax identification number',
    generateReport: 'Generate report',
    currentCost: 'Current cost',
    expectedCost: 'Expected cost',
    billingPeriods: 'Billing periods',
    invoices: 'Invoices',
    invoice: 'Invoice',
    expiration: 'Expiration',
    changeCreditCard: 'CHANGE CREDIT CARD',
    addCreditCard: 'ADD CREDIT CARD',
    changeData: 'CHANGE DATA',
    account: 'Account',
    enterCode: 'ENTER CODE',
    details: 'details',
    accountStatusDetails: 'Account status details',
    generalBalance: 'General balance',
    topUpAccount: 'TOP UP ACCOUNT',
    rechargeAccountWithACode: 'Recharge account with a promocode',
    enterTheCode: 'Enter the promocode',
    useYourFunds: 'USE YOUR FUNDS',
    billingPeriod: 'Billing periods',
    amount: 'Amount',
    paymentStatus: 'Payment status',
    downloadFiles: 'Download pdf file',
    report: 'Report',
    reports: 'Reports',
    payable: 'Payable',
    noCost: 'No cost',
    paid: 'Paid',
    unpaid: 'Transaction failed',
    partialPayment: 'Paid',
    paymentFor: 'Payment for',
    inProgress: 'a month in progress. We will inform you about the status of the transaction.',
    billingPeriodRepaymentFailedh2: 'Failed to collect payment.',
    billingPeriodRepaymentFailed:
      'Check your account balance or card activity. If you have any problems, please contact us via the support form.',
    billingPeriodRepaid: 'Transaction successful.',
    partialyPaidInfo1: 'The settlement period was PARTIALLY paid',
    partialyPaidInfo2:
      'Top up your account or add a credit card for additional payment. If you have any problems, please contact us via the support form.',
    awaitingPayment: 'Awaiting payment',
    payNow: 'PAY NOW',
    payExtraNow: 'PAY NOW',
    payment: 'Payment',
    showLess: 'Show less',
    showMore: 'Show more',
    prepaidBalance: 'Prepaid Balance',
    balance: 'Balance',
    promocodeBalance: 'Promocode Balance',
    activationDate: 'Activation date',
    code: 'Code',
    expenditureAndCodeValue: 'Expenditure and code value',
    validUntil: 'Expiration date',
    amountUsed: 'Amount used',
    viewReportFrom: 'View report from',
    orSelectADateRange: 'date range',
    display: 'DISPLAY',
    downloadTheReport: 'Download the report',
  },
  creditCards: {
    expirationMonth: 'Card expiry month',
    expirationYear: 'Card expiry year',
    contactInfo: 'Please contact us using the contact form.',
    disclaimer: 'I declare that I have read and accept {policyLink} and {termsLink}',
    policyLink: 'Privacy Policy',
    termsLink: 'Regulations',
    successfullyAdded: 'Credit card added successfully.',
    successInfo:
      'You will only be charged for the resources you use. To check your current costs go to the section in WORKSPACE SETTINGS / BILLINGS.',
    failDuringSubmit: 'Credit card information cannot be verified.',
    failInfo:
      'Transaction failed. Your credit card has not been added and will not be charged. Contact us using the HELP FORM.',
    failPossibleIssues: 'Possible causes of the error',
    expired: 'Card not valid (expired)',
    blocked: 'The card is blocked',
    noFunds: 'Charging of funds from the card is blocked',
  },
  users: {
    roleSelect: {
      owner: 'OWNER',
      admin: 'ADMIN',
      operator: 'OPERATOR',
      read_only: 'READ ONLY',
    },
    email: 'Email',
    name: 'Name',
    invited: 'invited - not activated yet',
    user: 'User',
    users: 'Users',
    inviteNewUser: 'INVITE A NEW USER',
    role: 'Role',
    changeRole: 'CHANGE ROLE',
    accessToBilling: 'Access to billing',
    newUser: 'New user',
    emailToThePerson: 'Enter the email address of the person you want to add',
    logInAgain: 'Log in again',
    invalidInvitationToken: 'Invitation could not be found.',
    clickAgain: 'Click the button below to accept the invitation to the workspace',
    accept: 'Accept',
  },
  logs: {
    logs: 'Logs',
    selectADateRange: 'Select a date range',
    downloadCSV: 'CSV FILE',
    daysAgo: 'days ago',
    success: 'Success',
    fail: 'Fail',
    running: 'Running',
    pending: 'Pending',
    emptyView: 'No logs available.',
  },
  routing: {
    description:
      'Routing allows you to select an outbound public IP address for each private network or individual network card.',
    info:
      'This address will be visible as the source address for external services when a connection is initiated from within the cloud.',
  },
  activation: {
    inactiveWorkspaceExists: 'You have already unactive workspace. Please activate it first.',
    request: 'REQUEST',
    startCodeInfo: 'Enter the start code provided from your service provider.',
    trialCode: 'START CODE',
    activatedWorkspace: 'Your workspace',
    chooseTrialActivationMethod: 'Select the method of activating the trial period',
    hasBeenActivated: ' has been activated',
    smsActivationEmailWarning: 'You can request a POLISH telephone number ONLY ONCE.',
    workspacePaymentInfo: 'Charges for resource usage will be billed and charged to your card at the end of the month.',
    checkMail: 'Message sent Check your email.',
    resendInfo: 'Message with password reset link not received? Click below to resend it.',
    ActivateRegion: 'Activate region',
    countryCode: 'Country code',
    switchRegion: 'Switch region',
    inactiveRegions: 'Inactive regions',
    chooseToActivate: '(choose to activate)',
    actualLocation: 'is the actual location of your infrastructure',
    favorableRegionInfo: 'The most favourable region is the one located close to the target users',
    regionInfraProcessing: 'Processing the construction of region infrastructure.',
    regionActivationError: 'An error occurred during region activation/deactivation',
    activationProcess: 'activation process',
    invalidLink:
      'The activation link is invalid. You are probably using it for the second time and the account has already been activated.',
    goToThePortal: 'Go to the portal',
    choosePaymentMethod: 'Select payment method and activate the workspace',
    youGetToUse: 'You can use',
    useThePromocode: 'Use the starter code to activate your trial.',
    paymentWillBeAutomaticallyTaken: 'The amount due will be automatically charged to your card.',
    payOnline: 'PAY ONLINE',
    payWithPayU: 'pay in advance with PayU',
    youHavePromoCode: 'DO YOU HAVE A PROMO CODE',
    youDontHavePromoCode: 'NO STARTER CODE?',
    promoCodeInfo: 'Send a request to activate your trial.',
    trialContactRequest: 'Please contact me about activating the trial.',
    trialMessageSent: 'A request has been sent to activate the trial.',
    nameAndSurnameOnCard: 'Name on the card',
    cardNumber: 'Card number',
    cardValidity: 'Valid through',
    newWorkspace: 'New Workspace',
    registerToOneStepCloud: 'Register at One Step Cloud',
    repeatPassword: 'Repeat password',
    thanks: 'Thank you!',
    onEMailAdress: 'To e-mail address',
    sendEMailInfo: 'we have sent you an email with a link to activate your account.',
    enterTheActivationCode: 'Enter activation code',
    didntGetActivationLink: 'You did not receive the message with the activation link?',
    trial: 'TRIAL',
    smsActivationEmail: 'To activate the panel trial, enter your phone number for verification.',
    smsActivationEmailCall: 'We will send you a VOICE MESSAGE providing the CONFIRMATION CODE.',
    theSamePhoneNumValidationInfo:
      'This phone number has already been used to activate the trial. Enter a different phone number.',
    phoneNum: 'Phone number',
    sendVoiceMessage: 'SEND VOICE MESSAGE',
    voiceMessage: 'Voice message',
    enterCode: 'Enter code',
    DidntReceiveSMS: "Didn't receive an SMS with a code?",
    useAtLeast: 'Use at least',
    eightCharacters: 'eight characters',
    including: ', including',
    lettersNumbersSymbols: 'letters, numbers, symbols',
    welcomeInOnestepCloud: 'Welcome to the One Step Cloud panel!',
    welcomeMessage:
      'Your account is already active. You can now create your first Workspace, the space where you will build your machine infrastructure.',
    createWorkspace: 'CREATE WORKSPACE',
    addNewWorkspace: 'ADD NEW WORKSPACE',
    regionError: 'An error occurred while setting the region.',
    returnToHomepage: 'Back to home page',
    successfullyApprovedNew: 'Successfully confirmed new email address',
    successfullyApprovedOld: 'Successfully confirmed change of address at the old address',
    useLink: 'Use the link sent to the',
    old: 'old',
    new: 'new',
    completeChange: 'address to complete the email address change process.',
    successfullyChanged: 'You have successfully changed your email address,',
    logIn: 'log in',
    logInUsingNew: 'again using the new email address',
    newWorkspaceInfo:
      'Workspace (work environment) enables team collaboration. User roles enable restricted permissions. You can set up production, test or development environments or create them for each project.',
    workspaceInfo:
      'Workspace (work environment) enables team collaboration. User roles enable restricted permissions. You can set up production, test or development environments or create them for each project.',
    invitations: 'Invitations',
    workspaces: 'Workspaces',
    infoAfterPromocodeRequest: 'Thank you! We will contact you shortly to activate your trial.',
  },
  removeDialog: {
    areYouSure: 'Are you sure?',
    createSnapshot: 'Are you sure you want to create a snapshot?',
    restoreSnapshot: 'Are you sure you want to restore the snapshot?',
    removeSnapshot: 'Are you sure you want to delete the snapshot?',
    wantToRemove: 'Are you sure you want to delete',
    wantToDeleteDedicatedMachine: 'Are you sure you want to end your dedicated machine rental? ',
    minimumRentalTime: 'If the minimum rental time is not exceeded, you will be charged up to its value.',
    wantToRemoveInvitation: 'Are you sure you want to delete the invitation?',
    wantToRemoveUser: 'Are you sure you want to delete the user?',
    wantToRemoveNetworkCard: 'Are you sure you want to remove the network card?',
    wantToResignIpAddress: 'Are you sure you want to stop using the public IP address',
    wantToRemoveNats: 'Are you sure you want to remove selected NAT mappings?',
    associatedFirewall: 'remove related firewall rules',
  },
  virtual_machine: {
    backup_activated: 'Backup activated {name} ({id})',
    backup_deactivated: 'Backup deactivated {name} ({id})',
    create: 'Create virtual machine {name} ({id})',
    update: 'Update virtual machine {name} ({id})',
    power_on: 'Power on virtual machine {name} ({id})',
    power_off: 'Power off virtual machine {name} ({id})',
    suspend: 'Suspend virtual machine {name} ({id})',
    restart: 'Reboot virtual machine {name} ({id})',
    destroy: 'Remove virtual machine {name} ({id})',
    console_access_granted: 'Guarantee access to the console for {name} ({id})',
    hardware: {
      update: 'Update virtual machine hardware {name} ({id})',
    },
    snapshot: {
      create: 'Create snapshot on {name} ({id})',
      destroy: 'Delete snapshot on {name} ({id})',
      restore: 'Restore snapshot on {name} ({id})',
    },
    nic: {
      update: 'Update network card {name} in machine {virtual_machine_name} ({virtual_machine_id})',
      create: 'Add network card to {name} to machine {virtual_machine_name} ({virtual_machine_id})',
      destroy: 'Delete network card {name} from {virtual_machine_name} ({virtual_machine_id})',
    },
  },
  dm_reservation: {
    requested: 'Create dedicated machine reservation',
    update: 'Update dedicated machine',
    create: 'Create dedicated machine reservation',
    destroy: 'Remove dedicated machine',
    power_on: 'Power on dedicated machine',
    power_off: 'Power off dedicated machine',
    reset: 'Reboot dedicated machine',
    nic: {
      update: 'Dedicated machine network card update',
    },
  },
  private_network: {
    create: 'Create private network {name}',
    update: 'Update private network {name}',
    destroy: 'Delete private network {name}',
    update_name: 'Private network name update',
  },
  public_ip_address: {
    create: 'Add public IP address {ip_address}',
    destroy: 'Delete public IP address {ip_address}',
    resign: 'Resign from public IP address {ip_address}',
    reserve: 'Reserve public IP address',
  },
  workspace_region: {
    destroy: 'Deactivate region {name}',
  },
  vpn_user: {
    create: 'Create VPN user',
    destroy: 'Delete VPN user',
  },
  usage_limit: {
    updated: 'Usage limits changed',
  },
  nat: {
    create: 'Add NAT mapping',
    bulk_destroy: 'Delete NAT mapping',
  },
  firewall_rules: {
    update: 'Update firewall rules',
  },
  region: {
    activate: 'Activate region {name}',
    deactivate: 'Deactivate region {name}',
  },
  user: {
    destroy: 'Remove user {name} ({email})',
    update: 'Update user',
    invitation: {
      create: 'Invite user {email}',
      accept: 'Accept invitation ({name}, {email})',
      destroy: 'Cancel invitation for {email}',
    },
  },
  vpn: {
    noVPNUsers: 'No VPN users',
    addFirstUser: 'Add first VPN user',
    manageUsers: 'Manage VPN users and share your workspace resources.',
    insufficentPermissions: 'Insufficient permissions to configure networking for a "read-only" role.',
    invalidUuid: 'User ID is incorrect. Contact us for more information.',
    loading: 'Download in progress...',
  },
  firewall: {
    noFirewallRules: 'No firewall rules',
    addFirstFIrewallRule: 'Add the first firewall rule',
    manageFirewallRules:
      'By default, the firewall does not contain any rules. Firewall is a global service for the region, it has no division into networks, machines etc. Firewall is a service independent of the rest of the infrastructure and fully managed by you.',
  },
  sms: {
    deliveryFailed: 'Failed to send the SMS voice message due to operator fault. Please try again later.',
    limitReached: 'SMS voice message limit reached. Please contact us.',
    confirmationRequired:
      'The new code could not be generated because the phone number to which the code was sent already exists. Please enter the code you received.',
    confirmed: 'Phone number already confirmed.',
    confirmedPhoneNumber: 'SMS voice message with confirmation code was sent to',
    enterTheConfirmationCode: 'Enter your confirmation code.',
    invalidConfirmationCode: 'Invalid confirmation code.',
    expiredCode: 'The confirmation code is no longer valid.',
  },
  faq: {
    wt: 'WORKSPACE',
    wq1: 'What is workspace?',
    wa1:
      'Workspace (work environment) enables team collaboration. User roles enable restricted permissions.\n' +
      'You can set up production, test or development environments or create them for each project.',
    wq2: 'What opportunities does workspace give me?',
    wa2:
      "Workspace is a separate entity. You can choose the currency, invoice details, and specify the payment system. You can also invite people to collaborate separately or be invited into someone's work environment.",
    wq3: 'How do I assign permissions to my workspace?',
    wa3:
      'You can invite your partners by sending them an invitation through the portal and define their respective roles, which will define the permissions they have. You can perform all these actions in the workspace settings using the users tab.',
    wq4: 'What are the permissions of specific roles?',
    wa4t1: 'Owner',
    wa4d1:
      'The Owner is a role that you get automatically when you set up your workspace. The Owner has all permissions, including:\n',
    wa4d1ada: 'Designating other users as owners,',
    wa4d1adb: 'Removing other users designated as owners,',
    wa4d1adc: 'Deleting the workspace,',
    wa4d1add: 'Changing the name of the workspace.',
    wa4t2: 'Admin',
    wa4d2:
      'Admin has permission to every action except the Owner permissions. Admin is able f.e. activate  Regions, manage the infrastructure, add new users, change the workspace name, manage payment and billing.',
    wa4t3: 'Operator',
    wa4d3:
      'The Operator is the Role only for user which is designed to manage only infrastructure of workspace (virtual machines, network, etc.).',
    wa4t4: 'Read only',
    wa4d4: 'This role allows you to view the workspace, but you will not be able to make any changes or actions.',
    gt: 'GENERAL INFO',
    gq1: 'Who are we?',
    ga1:
      "One Step Cloud is public cloud platform powered by Intratel which established 1997. We are experts in security and data availability solutions. We deliver, integrate and implement IT technologies of leading manufacturers. We are  VMware and Dell's Platinum partner. You can learn more about our services, technical capabilities and engineering background at Intratel.pl",
    gq2: 'What is One Step Cloud?',
    ga2:
      "One Step Cloud provide way to use flexibly computer resources without buying and maintaining it. Resources such as processors, memory and disk space in One Step Cloud can be used through an easy-to-use portal, easily changing size and level the use. One Step Cloud also allows you to create a hybrid cloud. In this model, the customer's data center resources are integrated with our Data Center. Such integrated resources can be used for secure data processing, launching customer-owned applications, systems and services.",
    gq3: 'Do your offer cover dedicated machines? What are they?',
    ga3:
      'Yes, In our offer we have a DM eqipped with GPU memory, STICK, Accelerators, FPGA or PCIE, which are usable in AI. To rent a DM just send a request using HelpForm and set out the details.',
    gq4: 'What if I am not satisfied with your services? Can I cancel?',
    ga4:
      'Yes. You are free to leave your account and delete it as qiuck as you will pay all invoices. After it you are able to delete an account. Please note, our cloud based on the widest virtualization standard as VMware is You are able . At any time you want, you can move all your resources to another cloud or install it physically on your own equipment.',
    gq5: 'What sets you apart from your competitors?',
    ga5t1: 'Data Centres in Poland and the USA',
    ga5d1:
      'Our Data Centers are located in Poland and USA. They meet high safety standards guaranteed, among others, by ISO certificates.',
    ga5t2: 'Engineering support',
    ga5d2:
      'One Step Cloud is based on the many years and extensive experience of Intratel engineers. We guarantee support in the migration of the entire infrastructure at a price and the support of specialists not only in the cloud but also in the network. Always available and committed. We give the opportunity to try out the infrastructure free of charge. We also provide an API to manage the environment, so that the customer can finally use the equipment only at certain times, by controlling their costs.',
    ga5t3: 'Public API',
    ga5d3:
      'One Step Cloud provide an public API which help you manage your Virtual Machines. You can save a money using it properly.',
    ga5t4: 'Fair rules',
    ga5d4:
      'We do not limit the use of infrastructure. We do not reduce efficiency during overuse of equipment to force the customer to purchase more resources. We have the ability to manage centrally.',
    st: 'STORAGE',
    sq1: 'Can I change the storage capacity during the month?',
    sa1t1: 'You can:',
    sa1d1: 'Increase disk space.',
    sa1t2: 'You can not:',
    sa1d2:
      'Decrease your drive space. It might to  lose your data. As other way we suggest and a new disk with smaller space, migrate all data and remove a bigger one from your VM.',
    sq2: 'Can I delete / add drives during the month?',
    sa2:
      'Yes, you can add and remove drives. Before deleting a drive, make sure that no important data is on it, as it will not be recoverable once deleted.',
    sq3: 'What types of drives are available?',
    sa3: 'One Step Cloud offers HDD, SSD and tape libraries for backup.',
    sq4: 'Can I add my disk to a virtual machine?',
    sa4: 'Yes. Just send a request to us using HelpForm and we are take care about it.',
    nt: 'NETWORK',
    nq1: 'How many IP do you provide to your users?',
    na1:
      'We are provide one public IP address for each Region each Workspace. If you wish is also possible to add new address in NETWORK tab ora during creation a new Virtual Machine. You can see the prices in calculator.',
    nq2: 'Can I set a reverse DNS record?',
    na2: 'It is impossible to set a reverse DNS record in One Step Cloud.',
    nq3: 'Are there any VPN limits?',
    na3:
      'There are no VPN limits. However, if you require more than 100 users, you should consult with us as to whether it would be more efficient to create a VPN using a client. The VPN is assigned to a region in a given workspace.',
    nq4: 'Which regions can I choose and what does it matter?',
    na4:
      'You can select regions located in Poland with the prefix "PL" or with the prefix "USA" (located in Santa Clara, United States of America). When you select a region, you decide where your data is stored physically, region, with fees charged based on the location. We recommend setting up a virtual machine in the region that will be closest to the end user.',
    bt: 'BILLING',
    bq1: 'What forms of payment are accepted?',
    ba1:
      'We accept all basic forms of payment such as Visa, MasterCard, Maestro, American Express and others. You can find more information here: https://paylane.pl/metody-platnosci/ . It is also possible to make a prepayment or settle on the basis  of an agreement and invoice, available after contacting a representative of our company.',
    bq2: 'How are resource use charges calculated?',
    ba2:
      'When you create a workspace, you choose a currency. Choose your legal form and enter your company details, as well as the form of payment to be used for your working environment. You pay by the second, and the settlement period is at the end of the calendar month. You only pay for what you have used.',
    bq3: 'Am I being charged when my machine is switched off?',
    ba3:
      'When the machine is switched off, you do not pay for computing power (vCPU) or operating memory (RAM). However, charges such as an operating system licence or an additional public IP address are accrued all the time.',
    bq4: 'How am I charged for resources?',
    ba4:
      'The prices of the resources are indicated when creating a virtual machine. The charge is billed on a per second basis.',
    bq5: 'How are charges for operating systems such as Windows Server billed?',
    ba5:
      'Operating system charges are billed every second. You pay for as many seconds as your virtual machine is created for. Sleep mode or shutting down a machine does not reduce costs.',
    bq6: 'How is the Promo code charged?',
    ba6: 'Promo code increases the balance of the workspace. It can only be used once per workspace.',
    bq7: 'How does the trial period work?',
    ba7:
      'The trial period is used to explore the functions of the portal. It can only be used once per user entering a specific phone number. The trial period lasts 30 days. After this time the workspace is blocked. To avoid blocking, you must activate one of the available payment methods.',
  },
  helpForm: {
    title: 'Help form',
    header: 'Issue or request - contact us',
    sendBtn: 'SEND',
    uploadFile: 'Upload file (jpg, png)',
    descriptionOne:
      'Our aim is to provide the most user-friendly platform for a virtual data centre. The official documentation can be found here ',
    descriptionTwo: 'If you have any issue or you need a help do not hesitate to contact us.',
    descriptionThree: 'We will do our best to quickly fix it.',
    ticketCreated: 'Notification created.',
    documentationInfo: 'If you have any questions or need further information, please refer to the documentation.',
    supportInfo:
      'Once you have submitted your notification, you will receive a confirmation message. We will try to get back to you with assistance as soon as possible. Support services and contact with the technical department is available only via email.',
    docsLink: 'http://docs.onestepcloud.pl',
    error: 'Error',
    usersIssue: 'Problem with access / invitations / users',
    slaRequest: 'SLA notification',
    unlock: 'Unlocking the workspace',
    newFeature: 'Ideas, new solutions',
    backup: 'Backup',
    customDM: 'Dedicated machines request',
    customOS: 'Additional operating system',
    resources: 'Resources - increasing limits',
    consoleAccess: 'Access to the virtual machine console',
    vmDiskImport: 'Importing a disk into a virtual machine',
    billingSupport: 'Billing - support',
    vmSupport: 'Virtual machines - import / support',
    networkSupport: 'Network - support',
    other: 'Other',
    descriptions: {
      error: '',
      usersIssue: '',
      slaRequest:
        ' * When inaccessibility began,\n' +
        ' * When inaccessibility ended,\n' +
        ' * What was unabled,\n' +
        ' * Additional description',
      unlock:
        'Please present the possibilities to unblock / top up workspace funds.\n' +
        ' * Workspace name:\n' +
        ' * Phone number:\n' +
        ' * E-mail:\n',
      newFeature: '',
      backup:
        'I would like to request a Backup for my Virtual Machine.\n' +
        ' * Virtual Machine name:\n' +
        ' * Start date for Backup:',
      customDM:
        'I would like to rent a Dedicated Machine. Below are the details:\n' +
        ' * Operating System name:\n' +
        ' * Operating System version:\n' +
        ' * Total CPU / GPU count: \n' +
        ' * Total Memory count: \n' +
        ' * Total Storage count: \n' +
        ' * Estimated usage Time (hours / days): \n' +
        ' * Additional information (i.e. STICK, Accelerator, FPGA, PCIE):',
      customOS:
        'I would like to install a custom operating system on a Virtual Machine which is not currently available on One Step Cloud. Below are the details:\n' +
        ' * Operating System name:\n' +
        ' * Operating System version:\n' +
        ' * ISO Download URL:\n' +
        ' * Additional information (i.e. language):',
      resources:
        'Please increase the limits in my workspace to a minimum:\n' +
        ' * Total vCPU count: \n' +
        ' * Total Memory count: \n' +
        ' * Total Storage count: \n' +
        ' * Total Public IP count: \n',
      consoleAccess:
        'I would like to request a direct Virtual Machine console access.\n' +
        ' * ID and Virtual Machine name:\n' +
        ' * Contact phone:',
      vmDiskImport:
        'I would like to import a Virtual Machine disk to One Step Cloud. Here is attached information needed for import:\n' +
        ' * Estimated Virtual Machine Disk size (after export):\n' +
        ' * Export file type:\n' +
        ' * Virtual Machine name:',
      billingSupport: '',
      vmSupport:
        'I would like to import a Virtual Machine to One Step Cloud. Here is information needed for import\n' +
        ' * Virtual Machine Operating System:\n' +
        ' * Estimated Virtual Machine size (after export):\n' +
        ' * Previous virtualization technology (or cloud provider):\n' +
        ' * Export file type:\n' +
        ' * Virtual Machine name:',
      networkSupport: '',
      other: '',
    },
  },
  costBilledPerSecond: 'Cost billed per second.',
  backupConfirmationInfoPart1: 'Are you sure you want switch on a backup service for this Virtual Machine?',
  backupConfirmationInfoPart2: 'Your backup will be performed daily, starting the next business day.',
  backupConfirmationInfoPart3: 'The backup fee consists of:',
  backupConfirmationInfoPart4: 'monthly fixed backup fee of',
  backupConfirmationInfoPart5: 'per machine',
  backupConfirmationInfoPart6: 'additional fee for the space used on a given machine',
  backupConfirmationInfoPart7: 'per',
  backupConfirmationInfoPart8: 'Any changes to the backup policy require contacting our helpdesk.\n',
  workspaces_exist: 'Must unsubscribe from workspaces first.',
  workspace: {
    create: 'Workspace has been created',
    blocked: 'Workspace has been blocked',
    block: 'Block workspace',
    unblock: 'Unblock workspace',
    admin_block: 'Block workspace administratively',
    admin_unblock: 'Unblock workspace administratively',
    closed: 'Delete workspace',
    console_policy_updated: 'Update the access rights to the console',
    activate: {
      promocode: 'Workspace has been activated (promocode)',
      prepaid: 'Workspace has been activated (prepaid)',
      contract: 'Workspace has been activated (contract)',
      trial: 'Workspace has been activated (trial code)',
    },
  },
  trial: {
    converted: 'Trial has been converted',
  },
  name_invalid: 'Please complete the form.',
  forbidden_last_owner: 'A minimum of one Owner per workspace is required.',
  workspace_with_contract:
    'An agreement has been concluded (individual offer). Contact us to terminate the agreement.\n',
  outstanding_debt_exists: 'There are unpaid billing periods.\n',
  trial_used: 'The trial has already been used.\n',
  trial_code_invalid: 'The start code is invalid or expired.\n',
  trial_code_used: 'The start code has already been used.\n',
  public_ip_address_in_use: 'The public address cannot be deleted because it is in use.\n',
  inactive_workspace: 'Inactive workspace.\n',
  blocked_workspace: 'Blocked workspace.\n',
  snapshot_exists: 'Before changing hardware settings, remove snapshot.\n',
  region_not_activated: 'Region not activated/deactivated (action failed).\n',
  blacklisted: 'The provided email address or phone number is on our blacklist.',
  token_invalid: 'Invalid token.',
  contract_exists: 'If you have a contract (individual offer) bill you are not able to add a card.',
  no_more_public_ip_addresses: 'No public IP addresses.',
  invalid_token: 'The token is not valid.',
  none_unit_available: 'No dedicated machine available.',
  trial_active: 'No permissions during the TRIAL.',
  min_usage_funds_missing: 'There are insufficient funds to cover the minimum cost.',
  fraud_risk_too_high:
    'The number you are trying to use has been detected as unsafe. Use another number or contact us.\n',
  activation_attempts_limit_exceeded: 'The limit of possible code attempts has been exceeded.\n',
  error: {
    primary_disk: {
      invalid: 'It is not possible to reduce disk size.',
    },
    private_network: {
      ip_address_not_available: 'There is no free IP address on the private network.',
    },
    invalid_power_state: 'Incorrect machine status. Required on, off status.',
    invalid_state: 'Incorrect status. Required status {params}.',
    end_time: {
      incorrect: 'The provided end date of the report period is incorrect.',
    },
    role: {
      blank: 'The role field is empty.\n',
      inclusion: 'Impossible to change role.\n',
    },
    phone_number: {
      invalid: 'Incorrect phone number format.\n',
      blank: 'Phone number is required.\n',
      confirmed: 'The phone number has already been used for confirmation.\n',
      confirmation_required: 'Confirmation is required.\n',
      invalid_confirmation_code: 'Confirmation code is invalid.\n',
      not_eligible: 'This number has already activated the trial and cannot be reused.\n',
      blacklisted: 'The phone number you entered cannot be used, please use a different one.\n',
      confirmation_attempts_limit_exceeded: 'The limit of possible code attempts has been exceeded.\n',
    },
    activation_attempts_limit_exceeded: 'The limit of possible code attempts has been exceeded.\n',
    phone_number_not_found: 'No number assigned to the account.\n',
    authorization: {
      invalid: 'There was a problem with authorization.\n',
    },
    name: {
      blank: 'Fill in field.\n',
      too_short: 'The name field is too short (minimum: {count}).\n',
      too_long: 'The name field is too long (maximum: {count}).\n',
    },
    username: {
      taken: 'The user name is already taken.\n',
      invalid: 'User name is has an invalid format.\n',
    },
    type: {
      blank: 'Fill in field.\n',
      too_short: 'The type field is too short (minimum: {count}).\n',
      inclusion: 'Select type.\n',
    },
    description: {
      blank: 'Fill in field.\n',
      too_short: 'The description field is too short (minimum: {count}).\n',
    },
    image: {
      file_type_invalid: 'Invalid file. Upload jpg or png.\n',
      too_big: 'The image is too large. Maximum file size: 5MB.\n',
    },
    cpu_cores: {
      limit_reached: 'The vCPU limit has been exceeded.\n',
    },
    ram: {
      limit_reached: 'The RAM limit has been exceeded.\n',
    },
    storage: {
      limit_reached: 'Disk space limit exceeded.\n',
    },
    public_networks: {
      limit_reached: 'The public IP addresses limit has been exceeded.\n',
    },
    power_not_manageable: 'Power cannot be manageable.\n',
    blank: 'cannot be blank.\n',
    too_short: 'has too few characters (minimum: {count}).\n',
    too_long: 'has too many characters (minimum: {count}).\n',
    taken: 'is already taken.\n',
    invalid: 'is invalid.\n',
    inclusion: 'is invalid.\n',
    not_a_number: 'is not a number.\n',
    greater_than: 'must be greater than {count}.\n',
    greater_than_or_equal_to: 'must be greater than or equal to {count}.\n',
    equal_to: 'must be equal to {count}.\n',
    less_than: 'must be less than {count}.\n',
    less_than_or_equal_to: 'must be less than or equal to {count}.\n',
    not_an_integer: 'is not an integer.\n',
    network: {
      collision: 'Conflict with another network.\n',
      forbidden: 'forbidden address.\n',
    },
    ip_address: {
      collision: 'Conflicts with another service.\n',
    },
    private_network_id: {
      collision: 'Conflicts with another network card.\n',
    },
    email: {
      blank: 'Email is required.\n',
      invalid: 'Invalid email address.\n',
      already_invited: 'The user has already been invited.\n',
      taken: 'The email address is already taken.\n',
      blacklisted: 'The specified email address cannot be used, please use a different one.\n',
    },
    public_key: {
      not_unique: 'Public key already exists.\n',
      invalid: 'Public key is invalid.\n',
      blank: 'The public key is required.\n',
    },
    password: {
      blank: 'Password required.\n',
      too_short: 'Password too short. A minimum of 8 characters is required.\n',
    },
    source_port: {
      overlapping: 'Overlaps with another NAT.\n',
    },
    code: {
      used_by_account: 'The code was already used by your account.\n',
      used_in_workspace: 'The code was already used to fund your workspace account.\n',
      invalid: 'The code is invalid.\n',
    },
    current_password: {
      invalid: 'Incorrect old password.\n',
    },
    nic: {
      blank: 'Private IP address is required.\n',
    },
    nic_id: {
      not_active: 'It is not possible to create a NAT on an unconnected network.\n',
    },
    destination_port: {
      range_mismatch: 'Ports range mismatch.\n',
    },
    source_port_range: {
      invalid: 'Source port range is invalid.\n',
    },
    destination_port_range: {
      invalid: 'Destination port range is invalid.\n',
    },
    source_ip: {
      blank: 'Source IP address is required.\n',
      invalid: 'Source IP address is invalid.\n',
    },
    destination_ip: {
      blank: 'Destination IP address is required.\n',
      invalid: 'Destination IP address is invalid.\n',
    },
    protocol: {
      blank: 'The protocol field is required.\n',
      inclusion: 'Enable protocol.\n',
    },
    city: {
      blank: 'The city field is required.\n',
      too_short: 'The city field is too short. Use at least 2 characters.\n',
    },
    address: {
      blank: 'Address field is required.\n',
      too_short: 'Address field is too short.\n Use at least 2 characters.\n',
    },
    zip_code: {
      blank: 'The postal code field is required.\n',
      too_short: 'The postcode field is too short.\n Use at least 2 characters.\n',
    },
    tax_id: {
      blank: 'The tax identification number field is required.\n',
      invalid: 'The tax identification number field is incorrect.\n',
    },
    currency: {
      invalid: 'The currency field is required.\n',
    },
  },
  country: {
    Afghanistan: 'Afghanistan',
    ÅlandIslands: 'Åland Islands',
    Albania: 'Albania',
    Algeria: 'Algeria',
    AmericanSamoa: 'American Samoa',
    Andorra: 'Andorra',
    Angola: 'Angola',
    Anguilla: 'Anguilla',
    Antarctica: 'Antarctica',
    AntiguaandBarbuda: 'Antigua and Barbuda',
    Argentina: 'Argentina',
    Armenia: 'Armenia',
    Aruba: 'Aruba',
    Australia: 'Australia',
    Austria: 'Austria',
    Azerbaijan: 'Azerbaijan',
    Bahamas: 'Bahamas',
    Bahrain: 'Bahrain',
    Bangladesh: 'Bangladesh',
    Barbados: 'Barbados',
    Belarus: 'Belarus',
    Belgium: 'Belgium',
    Belize: 'Belize',
    Benin: 'Benin',
    Bermuda: 'Bermuda',
    Bhutan: 'Bhutan',
    Bolivia: 'Bolivia',
    PlurinationalStateofBonaire: 'Plurinational State of Bonaire',
    SintEustatiusandSaba: 'Sint Eustatius and Saba',
    BosniaandHerzegovina: 'Bosnia and Herzegovina',
    Botswana: 'Botswana',
    BouvetIsland: 'Bouvet Island',
    Brazil: 'Brazil',
    BritishIndianOceanTerritory: 'British Indian Ocean Territory',
    BruneiDarussalam: 'Brunei Darussalam',
    Bulgaria: 'Bulgaria',
    BurkinaFaso: 'Burkina Faso',
    Burundi: 'Burundi',
    Cambodia: 'Cambodia',
    Cameroon: 'Cameroon',
    Canada: 'Canada',
    CapeVerde: 'Cape Verde',
    CaymanIslands: 'Cayman Islands',
    CentralAfricanRepublic: 'Central African Republic',
    Chad: 'Chad',
    Chile: 'Chile',
    China: 'China',
    ChristmasIsland: 'Christmas Island',
    CocosKeelingIslands: 'Cocos Keeling Islands',
    Colombia: 'Colombia',
    Comoros: 'Comoros',
    Congo: 'Congo',
    DemocraticRepublicoftheCongo: 'Democratic Republic of the Congo',
    CookIslands: 'Cook Islands',
    CostaRica: 'Costa Rica',
    CôtedIvoire: 'Côted Ivoire',
    Croatia: 'Croatia',
    Cuba: 'Cuba',
    Curaçao: 'Curaçao',
    Cyprus: 'Cyprus',
    CzechRepublic: 'Czech Republic',
    Denmark: 'Denmark',
    Djibouti: 'Djibouti',
    Dominica: 'Dominica',
    DominicanRepublic: 'Dominican Republic',
    Ecuador: 'Ecuador',
    Egypt: 'Egypt',
    ElSalvador: 'El Salvador',
    EquatorialGuinea: 'Equatorial Guinea',
    Eritrea: 'Eritrea',
    Estonia: 'Estonia',
    Ethiopia: 'Ethiopia',
    FalklandIslands: 'Falkland Islands',
    FaroeIslands: 'Faroe Islands',
    Fiji: 'Fiji',
    Finland: 'Finland',
    France: 'France',
    FrenchGuiana: 'French Guiana',
    FrenchPolynesia: 'French Polynesia',
    FrenchSouthernTerritories: 'French Southern Territories',
    Gabon: 'Gabon',
    Gambia: 'Gambia',
    Georgia: 'Georgia',
    Germany: 'Germany',
    Ghana: 'Ghana',
    Gibraltar: 'Gibraltar',
    Greece: 'Greece',
    Greenland: 'Greenland',
    Grenada: 'Grenada',
    Guadeloupe: 'Guadeloupe',
    Guam: 'Guam',
    Guatemala: 'Guatemala',
    Guernsey: 'Guernsey',
    Guinea: 'Guinea',
    GuineaBissau: 'Guinea Bissau',
    Guyana: 'Guyana',
    Haiti: 'Haiti',
    HeardIslandandMcDonaldIslands: 'Heard Island and McDonald Islands',
    HolySeeVaticanCityState: 'Holy See Vatican City State',
    Honduras: 'Honduras',
    HongKong: 'Hong Kong',
    Hungary: 'Hungary',
    Iceland: 'Iceland',
    India: 'India',
    Indonesia: 'Indonesia',
    Iran: 'Iran Islamic Republic',
    IslamicRepublicIraq: 'Iraq',
    Ireland: 'Ireland',
    IsleofMan: 'Isle of Man',
    Israel: 'Israel',
    Italy: 'Italy',
    Jamaica: 'Jamaica',
    Japan: 'Japan',
    Jersey: 'Jersey',
    Jordan: 'Jordan',
    Kazakhstan: 'Kazakhstan',
    Kenya: 'Kenya',
    Kiribati: 'Kiribati',
    NorthKorea: 'North Korea',
    SouthKorea: 'South Korea',
    RepublicofKuwait: 'Republic of Kuwait',
    Kyrgyzstan: 'Kyrgyzstan',
    LaoDemocraticRepublic: 'Lao Democratic Republic',
    Latvia: 'Latvia',
    Lebanon: 'Lebanon',
    Lesotho: 'Lesotho',
    Liberia: 'Liberia',
    Libya: 'Libya',
    Liechtenstein: 'Liechtenstein',
    Lithuania: 'Lithuania',
    Luxembourg: 'Luxembourg',
    Macao: 'Macao',
    Macedonia: 'Macedonia',
    Madagascar: 'Madagascar',
    Malawi: 'Malawi',
    Malaysia: 'Malaysia',
    Maldives: 'Maldives',
    Mali: 'Mali',
    Malta: 'Malta',
    MarshallIslands: 'Marshall Islands',
    Martinique: 'Martinique',
    Mauritania: 'Mauritania',
    Mauritius: 'Mauritius',
    Mayotte: 'Mayotte',
    Mexico: 'Mexico',
    Micronesia: 'Micronesia',
    Moldova: 'Moldova',
    Monaco: 'Monaco',
    Mongolia: 'Mongolia',
    Montenegro: 'Montenegro',
    Montserrat: 'Montserrat',
    Morocco: 'Morocco',
    Mozambique: 'Mozambique',
    Myanmar: 'Myanmar',
    Namibia: 'Namibia',
    Nauru: 'Nauru',
    Nepal: 'Nepal',
    Netherlands: 'Netherlands',
    NewCaledonia: 'New Caledonia',
    NewZealand: 'New Zealand',
    Nicaragua: 'Nicaragua',
    Niger: 'Niger',
    Nigeria: 'Nigeria',
    Niue: 'Niue',
    NorfolkIsland: 'Norfolk Island',
    NorthernMarianaIslands: 'Northern Mariana Islands',
    Norway: 'Norway',
    Oman: 'Oman',
    Pakistan: 'Pakistan',
    Palau: 'Palau',
    PalestinianTerritoryOccupied: 'Palestinian Territory, Occupied',
    Panama: 'Panama',
    PapuaNewGuinea: 'Papua New Guinea',
    Paraguay: 'Paraguay',
    Peru: 'Peru',
    Philippines: 'Philippines',
    Pitcairn: 'Pitcairn',
    Poland: 'Poland',
    Portugal: 'Portugal',
    PuertoRico: 'Puerto Rico',
    Qatar: 'Qatar',
    Réunion: 'Réunion',
    Romania: 'Romania',
    RussianFederation: 'Russian Federation',
    Rwanda: 'Rwanda',
    SaintBarthélemy: 'Saint Barthélemy',
    SaintHelena: 'Saint Helena, Ascension and Tristan da Cunha',
    SaintKittsandNevis: 'Saint Kitts and Nevis',
    SaintLucia: 'Saint Lucia',
    SaintMartinFrenchpart: 'Saint Martin (French part)',
    SaintPierreandMiquelon: 'Saint Pierre and Miquelon',
    SaintVincentandtheGrenadines: 'Saint Vincent and the Grenadines',
    Samoa: 'Samoa',
    SanMarino: 'San Marino',
    SaoTomeandPrincipe: 'Sao Tome and Principe',
    SaudiArabia: 'Saudi Arabia',
    Senegal: 'Senegal',
    Serbia: 'Serbia',
    Seychelles: 'Seychelles',
    SierraLeone: 'Sierra Leone',
    Singapore: 'Singapore',
    SintMaartenDutchPart: 'Sint Maarten (Dutch part)',
    Slovakia: 'Slovakia',
    Slovenia: 'Slovenia',
    SolomonIslands: 'Solomon Islands',
    Somalia: 'Somalia',
    SouthAfrica: 'South Africa',
    SouthGeorgiaandtheSouthSandwichIslands: 'South Georgia and the South Sandwich Islands',
    SouthSudan: 'South Sudan',
    Spain: 'Spain',
    SriLanka: 'Sri Lanka',
    Sudan: 'Sudan',
    Suriname: 'Suriname',
    SvalbardandJanMayen: 'Svalbard and Jan Mayen',
    Swaziland: 'Swaziland',
    Sweden: 'Sweden',
    Switzerland: 'Switzerland',
    SyrianArabRepublic: 'Syrian Arab Republic',
    Taiwan: 'Taiwan',
    Tajikistan: 'Tajikistan',
    Tanzania: 'Tanzania',
    Thailand: 'Thailand',
    TimorLeste: 'Timor-Leste',
    Togo: 'Togo',
    Tokelau: 'Tokelau',
    Tonga: 'Tonga',
    TrinidadandTobago: 'Trinidad and Tobago',
    Tunisia: 'Tunisia',
    Turkey: 'Turkey',
    Turkmenistan: 'Turkmenistan',
    TurksandCaicosIslands: 'Turks and Caicos Islands',
    Tuvalu: 'Tuvalu',
    Uganda: 'Uganda',
    Ukraine: 'Ukraine',
    UnitedArabEmirates: 'United Arab Emirates',
    UnitedKingdom: 'United Kingdom',
    UnitedStates: 'United States',
    UnitedStatesMinorOutlyingIslands: 'United States Minor Outlying Islands',
    Uruguay: 'Uruguay',
    Uzbekistan: 'Uzbekistan',
    Vanuatu: 'Vanuatu',
    Venezuela: 'Venezuela',
    VietNam: 'Viet Nam',
    VirginIslandsBritish: 'Virgin Islands, British',
    VirginIslandsUS: 'Virgin Islands, U.S.',
    WallisandFutuna: 'Wallis and Futuna',
    WesternSahara: 'Western Sahara',
    Yemen: 'Yemen',
    Zambia: 'Zambia',
    Zimbabwe: 'Zimbabwe',
  },
  months: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
};
